import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App.jsx';

// ── Sentry Error Tracking (solo in produzione) ────────────────────────────
if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
    Sentry.init({
        dsn: import.meta.env.VITE_SENTRY_DSN,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: false,
                blockAllMedia: false,
            }),
        ],
        // Campiona il 10% delle sessioni in produzione (aumenta se serve più dettaglio)
        tracesSampleRate: 0.1,
        // Cattura il 10% delle sessioni replay (solo in caso di errore: 100%)
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        environment: import.meta.env.MODE,
        release: `onet-crm@${import.meta.env.VITE_APP_VERSION || '1.0.0'}`,
    });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
